<template>
	<ul>
	    <li class="cursor-pointer border-bottom pt-1 pb-2 px-2" v-for="(contact, index) in getFilterDependencies" :key="index">
	        <vs-row class="mt-5">
	            <vs-col  vs-type="flex"  vs-align="flex-end" vs-w="10" vs-sm="12" class="text-left">
	                <!-- <div class="w-full" @click="$emit('answer',contact.answer || contact.answers)"> -->
	                <div class="w-full" @click="getAnswer(contact)">
	                    <span class="block font-bold">
	                        {{index}}	                       
	                    </span>
	                    <p class="truncate ">
	                        {{contact.label}}
	                    </p>                                                        
	                </div>
	            </vs-col>
	            <vs-col  vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2" vs-sm="12" class="text-left">
	                <feather-icon class="ml-3"  icon="Trash2Icon" svgClasses="h-7 w-7" @click="$emit('deleteDependence',index)"/>
	            </vs-col>
	        </vs-row>                                           
	    </li>
	</ul>
</template>

<script type="text/javascript">
	export default {
		props: {
			getFilterDependencies: {
				type: [Array, Object],
				required: false,
				default: []
			}
		},
		methods: {
			getAnswer(question) {				
				if(question.answer !== undefined) {
					if(typeof(question.answer) === 'number') {						
						this.$emit('answer',String(question.answer));	
					} 
					this.$emit('answer',question.answer)
				}else this.$emit('answer',String(question.answers))
			}
		}		
	}
</script>